import { createContext } from "react";

export const LeaseContext = createContext({
  lease: {},
  onChange: () => {},
});
